export default {
  namespaced: true,

  state: {
    userId: "",
    studentOpportunityId: 0,
    studentOpportunityAdditionalMaterialId: 0,
    goals: [],
    contact: {},
    supervisors: [],
    studentOpportunity: {},
    studentOpportuninityAdditionalMaterial: {}
  },

  mutations: {
    SET_GOALS(state, payload) {
      state.goals = payload;
    },
    SET_USERID(state, payload) {
      state.userId = payload;
    },
    SET_STUDENTOPPORTUNITYID(state, payload) {
      state.studentOpportunityId = payload;
    },
    SET_STUDENTOPPORTUNITYADDITIONALMATERIALID(state, payload) {
      state.studentOpportunityAdditionalMaterialId = payload;
    },
    SET_CONTACT(state, payload) {
      state.contact = payload;
    },
    SET_SUPERVISORS(state, payload) {
      state.supervisors = payload;
    },
    SET_STUDENTOPPORTUNITY(state, payload) {
      state.studentOpportunity = payload;
    },
    SET_STUDENTOPPORTUNITYADDITIONALMATERIAL(state, payload) {
      state.studentOpportuninityAdditionalMaterial = payload;
    }
  },

  actions: {
    setGoals(context, goals) {
      context.commit("SET_GOALS", goals);
    },
    setUserId(context, data) {
      context.commit("SET_USERID", data);
    },
    setStudentOpportunityId(context, data) {
      context.commit("SET_STUDENTOPPORTUNITYID", data);
    },
    setStudentOpportunityAdditionalMaterialId(context, data) {
      context.commit("SET_STUDENTOPPORTUNITYADDITIONALMATERIALID", data);
    },
    setContact(context, data) {
      context.commit("SET_CONTACT", data);
    },
    setSupervisors(context, data) {
      context.commit("SET_SUPERVISORS", data);
    },
    setStudentOpportunity(context, data) {
      context.commit("SET_STUDENTOPPORTUNITY", data);
    },
    setStudentOpportunityAdditionalMaterial(context, data) {
      context.commit("SET_STUDENTOPPORTUNITYADDITIONALMATERIAL", data);
    },
    reset(context) {
      context.commit("SET_GOALS", []);
      context.commit("SET_USERID", "");
      context.commit("SET_STUDENTOPPORTUNITYID", 0);
      context.commit("SET_STUDENTOPPORTUNITYADDITIONALMATERIALID", 0);
      context.commit("SET_CONTACT", {});
      context.commit("SET_SUPERVISORS", []);
      context.commit("SET_STUDENTOPPORTUNITY", {});
      context.commit("SET_STUDENTOPPORTUNITYADDITIONALMATERIAL", {});
    }
  }
};
